import { StorageObjectReqRes, HoldingStorageObjectReqRes } from 'src/app/shared/models/StorageObjectReqRes.model';
import { SearchOptionsResponse } from 'src/app/shared/models/SearchOptionsResponse.model';

export class StorageObjectSearchOptionsResponse extends SearchOptionsResponse<HoldingStorageObjectReqRes> {
  public parentFolders: StorageObjectReqRes[];
}
